import { useState } from "react";
import { useNavigate } from "react-router-dom";
import PhoneInput from "react-phone-input-2";
import 'react-phone-input-2/lib/style.css'
import Select from "react-select";
import RequiredFeild from "../../Atoms/RequiredFeild";
import IbanFeild from "../../Atoms/IbanFeild";
import { DatePickerInput } from "rc-datepicker";
import "rc-datepicker/lib/style.css";
import PostData from '../../../Api/PostData'
import IBAN from 'iban'
import Navbar from "../../Atoms/Navbar"

const InitalForm = () => {

    const history = useNavigate();
    const initialState = {
        Type: '',
        CNIC: '',
        IssueDate: '',
        FullName: '',
        email: '',
        IBANnumber: '',
        IBANError: false,
        phone: '',
        relationWithMobileNo: '',
        count: '',
        Status: '',
        loading: false,
        error: '',
        login: false
    }

    const [formData, setformData] = useState(initialState);
    const { Type, CNIC, IssueDate, FullName, email, IBANnumber, IBANError, phone, relationWithMobileNo, count, Status, loading, error, login } = formData;

    const handleChange = (e) => {
        const { name, value, type, files, checked } = e.target


        if (type === "checkbox") {
            setformData({
                ...formData,
                [name]: checked,
            });
        }
        else if (type === "file") {

            if (files[0].size / 1024 < 6145) {
                setformData({
                    ...formData,
                    [name]: files,
                });
            }
            else {
                alert('File size must be below 5 MB')
            }
        }
        else if (name === 'FullName' || name === 'RelativeName') {
            setformData({
                ...formData,
                [name]: value.replace(/[^a-zA-Z\s]/gi, '')
            });
        }
        else if (name === 'street' || name === 'Apt' || name === 'street' || name === 'MailApt' || name === 'EmployStreet' || name === 'EmployApt' || name === "sourceofincome") {
            setformData({
                ...formData,
                [name]: value.replace(/[^a-zA-Z0-9\-#\s]/gi, '')
            });
        }
        else if (name === 'CNIC' || name === 'RelativeCNIC') {
            setformData({
                ...formData,
                [name]: value.replace(/[^0-9]/gi, '')
            });
        }
        else if (name === 'email') {
            setformData({
                ...formData,
                [name]: value
            });
        }
        else {
            setformData({
                ...formData,
                [name]: value.replace(/[^0-9a-zA-Z\s]/gi, '')
            });
        }
    };

    const handleDrctChange = (name, e) => {
        console.log({ name, e })
        setformData({
            ...formData, [name]: e
        })


        if (name == 'IBANnumber') {
            setformData({
                ...formData,
                IBANnumber: e,
                IBANError: !IBAN.isValid(e['iban'])
            });
        }
    };

    const handleSubmit = (e) => {
        e?.preventDefault();

        const res = PostData.MiniForm(formData);
        res.then((value) => {
            console.log("Res", value);
            if (value.data) {
                history('/Otp')
            }
            //   else {
            //     message.error(value.data);
            //   }
        });
    }



    const IDType = [
        { value: "CNIC", label: "CNIC" },
        { value: "NICOP", label: "NICOP" },
        { value: "POC", label: "POC" },
        { value: "SNIC", label: "SNIC" },
    ];


    const residentialStatus = [
        { value: "01", label: "Resident" },
        { value: "02", label: "Non-Resident" },
    ];

    const Relation = [
        { value: "1", label: "Self" },
        { value: "2", label: "Father" },
        { value: "3", label: "Mother" },
        { value: "4", label: "Son" },
        { value: "5", label: "Daughter" },
        { value: "6", label: "Husband" },
        { value: "7", label: "Company" },
    ];

    const onChangeDate = (event, name, minDate, maxDate) => {
        let dateConvert = convert(event);

        handleDrctChange(name, dateConvert);
    };

    const convert = (str) => {

        var date = new Date(str),
            mnth = date.toLocaleString('default', { month: 'short' }),
            day = ("0" + date.getDate()).slice(-2);
        return [day, mnth, date.getFullYear()].join("-");
    }



    return (
        <>
            <Navbar />
            <div className="bg-grey-100 centerr">
                <div className="Emailform">
                    <div className='verify-bg'>
                        <div className='container'>
                            <h1 className='text-white  verif-text'>Initial Details</h1>
                        </div>
                    </div>
                    <div className="bg-white p-3">

                        <form onSubmit={handleSubmit}>

                            <div>
                                <label
                                    htmlFor="IDType"
                                    className="col-12 col-form-label fw-500"
                                >
                                    Identification Card
                                </label>
                                <Select
                                    onChange={(e) => handleDrctChange("Type", e)}
                                    placeholder="ID Type"
                                    defaultInputValue={Type.label}
                                    options={IDType}
                                    id="IDType"
                                    className='mb-3'
                                />
                                {Type == "" && (
                                    <RequiredFeild />
                                )}
                            </div>

                            <div>

                                <label
                                    htmlFor="CNIC"
                                    className="col-12 col-form-label fw-500"
                                >
                                    CNIC
                                </label>

                                <input
                                    type="text"
                                    name="CNIC"
                                    className="form-control"
                                    placeholder="CNIC Number"
                                    value={CNIC}
                                    onChange={handleChange}
                                    id="CNIC"
                                    minLength='13'
                                    maxLength="13"
                                    required
                                />

                            </div>

                            <div>

                                <label
                                    htmlFor="FullName"
                                    className="col-12 col-form-label fw-500"
                                >
                                    Full Name
                                </label>
                                <input
                                    type="text"
                                    name="FullName"
                                    className="form-control mb-3"
                                    placeholder="Full Name *"
                                    value={FullName}
                                    onChange={handleChange}
                                    id="FullName"
                                    required
                                />

                            </div>

                            <div>

                                <label
                                    htmlFor="email"
                                    className="col-12 col-form-label fw-500"
                                >
                                    Email
                                </label>
                                <input
                                    type="email"
                                    name="email"
                                    className="form-control mb-3"
                                    placeholder="Email Address *"
                                    value={email}
                                    onChange={handleChange}
                                    id="email"
                                    required
                                />

                            </div>

                            <div className={` ${IBANError && IBANnumber.value ? 'brdr-error' : 'qw'}`} >

                                <label
                                    htmlFor="IBAN"
                                    className="col-12 col-form-label fw-500">
                                    IBAN Number
                                </label>


                                <IbanFeild
                                    initialValue={IBANnumber.value}
                                    onChange={(e) => { handleDrctChange("IBANnumber", e) }}
                                    value={IBANnumber.value}
                                    iban={IBANnumber.iban}
                                    Err={IBANError} />
                                {IBANError && (
                                    <input
                                        tabIndex={-1}
                                        className="ReqFeild"
                                        autoComplete={'' + Math.random()}
                                        required={true}
                                        value=''
                                        onInvalid={(e) => { e.target.setCustomValidity('Enter the Correct IBAN Number') }}
                                    />
                                )}
                                <p className="fw-400 fs14 t-grey-400">
                                    Please carefully input your 24 characters IBAN Number.
                                </p>
                            </div>


                            <div>
                                <label
                                    htmlFor="Number"
                                    className="col-12 col-form-label fw-500">
                                    Mobile Number
                                </label>

                                <PhoneInput
                                    value={phone}
                                    placeholder="Enter phone"
                                    inputProps={{
                                        name: "phone",
                                        required: true,
                                    }}
                                    containerClass="mb-3"
                                    country={"pk"}
                                    onChange={(text) => setformData({
                                        ...formData, count: 1, phone: text
                                    })}
                                    inputClass="form-control mb-3 w-100"
                                    isValid={(inputNumber, value, country) => {
                                        const newStr = inputNumber.replace(
                                            value.dialCode,
                                            ""
                                        );
                                        if (value.dialCode === "") {
                                            return "Select Country Code";
                                        } else if (newStr === "" && count) {
                                            return "Phone number required";
                                        } else {
                                            return true;
                                        }
                                    }}
                                />
                            </div>

                            <div>
                                <label
                                    htmlFor="residentialStatus"
                                    className="col-12 col-form-label fw-500"
                                >
                                    Residential Status
                                </label>
                                <Select
                                    onChange={(e) => handleDrctChange("Status", e)}
                                    placeholder="Residential Status"
                                    defaultInputValue={Status.label}
                                    options={residentialStatus}
                                    id="residentialStatus"
                                    className='mb-3'
                                />
                                {Status == "" && (
                                    <RequiredFeild />
                                )}
                            </div>

                            <div>
                                <label
                                    htmlFor="Relation"
                                    className="col-12 col-form-label fw-500"
                                >
                                    Relation
                                </label>
                                <Select
                                    onChange={(e) => handleDrctChange("relationWithMobileNo", e)}
                                    placeholder="Residential relationWithMobileNo"
                                    defaultInputValue={relationWithMobileNo.label}
                                    options={Relation}
                                    id="Relation"
                                    className='mb-3'
                                />
                                {relationWithMobileNo == "" && (
                                    <RequiredFeild />
                                )}
                            </div>



                            <div>

                                <label
                                    htmlFor="issueDay"
                                    className="col-12 col-form-label fw-500"
                                >
                                    Issue Date
                                </label>

                                <DatePickerInput
                                    onChange={(e) => onChangeDate(e, 'IssueDate', new Date('05/11/2019'), new Date())}
                                    className="my-custom-datepicker-component mb-3"
                                    defaultValue={IssueDate.includes('N') ? '' : IssueDate}
                                    name='DatePicker'
                                    placeholder="DD-MM-YYYY"
                                    maxDate={new Date()}
                                    startDate={new Date()}
                                    // readOnly
                                    maxLength="10"
                                    showOnInputClick={true}
                                    displayFormat='DD/MM/YYYY'
                                    required
                                />
                                {IssueDate === "" && (
                                    <RequiredFeild />
                                )}
                            </div>


                            <button
                                className="btn-filled fs16 px-3 py-3 w-100"
                                type="submit"
                            >
                                Register
                            </button>
                            <p className="text-danger fs12 text-center">{error}</p>
                        </form>

                    </div>

                </div>
            </div>
        </>
    );
}

export default InitalForm;